import { render } from "./QuestionView.vue?vue&type=template&id=b9f9aaaa&scoped=true"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"

import "./QuestionView.vue?vue&type=style&index=0&id=b9f9aaaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f9aaaa"]])

export default __exports__